import { render, staticRenderFns } from "./CruiseDetail.vue?vue&type=template&id=5bb6de86&scoped=true"
import script from "./CruiseDetail.vue?vue&type=script&lang=js"
export * from "./CruiseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6de86",
  null
  
)

export default component.exports